<div class="container-fluid viewBox gap-3">
    <div>
        <button class="closeHeader" (click)="closeDialog()">
            <img src="./assets/images/close cross.svg" alt="Unable to load image">
        </button>
    </div>
    <div class="row title">
        Student Details
    </div>
    <div class="row field">
        <div class="col-lg-4 col-md-6 ">
            <label>First Name</label>
            <p>{{data.firstName}}</p>
        </div>
        <div class="col-lg-4 col-md-6 ">
            <label>Last Name</label>
            <p>{{data.lastName}}</p>
        </div>
        <div class="col-lg-4 col-md-6 ">
            <label>Date Of Birth</label>
            <p>{{data.dob | date:'yyyy-MM-dd'}}</p>
        </div>
    </div>
    <div class="row field">
        <div class="col-lg-4 col-md-6 col-sm-6">
            <label>Location</label>
            <p>{{data.campusName}}</p>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6">
            <label>Member ID</label>
            <p>{{data.ssn}}</p>
        </div>
    </div>
    <div class="row field">
        <div class="col-lg-4 col-md-6 col-sm-6">
            <label>Coverage Effective Date</label>
            <p>{{data.coverageStart | date:'yyyy-MM-dd'}}</p>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6">
            <label>Coverage Expiration Date</label>
            <p>{{data.coverageEnd | date:'yyyy-MM-dd'}}</p>
        </div>
    </div>
    <div class="row field">
        <div class="col-lg-4 col-md-6 col-sm-6">
            <label>Payment Information</label>
            <p>{{data.paymentType}}</p>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6">
            <label>Plan Description</label>
            <p>{{data.activity}}</p>
        </div>
    </div>
</div>